import React, { lazy } from 'react';
import { CheckCircle2, Maximize, DoorOpen, ShieldAlert } from 'lucide-react';
export function SideDoorRear() {
  const items = [{
    title: 'Side Window Replacement',
    icon: <Maximize className="w-6 h-6 text-brand-blue" data-id="element-407" />,
    bullets: ['Driver and passenger side windows', 'Power window glass and quarter glass', 'Cars, trucks, vans and SUVs']
  }, {
    title: 'Door Glass Replacement',
    icon: <DoorOpen className="w-6 h-6 text-brand-blue" data-id="element-408" />,
    bullets: ['Shattered or broken car door glass', 'Most domestic and foreign vehicles', 'Cleanup of broken glass from the door']
  }, {
    title: 'Rear Window Replacement',
    icon: <ShieldAlert className="w-6 h-6 text-brand-blue" data-id="element-409" />,
    bullets: ['Cracked or shattered rear glass', 'Defrost line reconnection where applicable', 'Truck rear windows and back glass']
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-410">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center mb-16" data-id="element-412">
          <div className="order-2 lg:order-1 scroll-slide-left" data-id="element-413">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-414">
              Side, Door & Rear Window Replacement
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-415">
              A shattered side window or broken rear glass leaves your vehicle
              exposed to weather, theft and further damage. Kosin's Glass
              replaces side, door and rear glass for most makes and models, with
              quality glass and certified installation.
            </p>
          </div>

          <div className="order-1 lg:order-2 relative scroll-slide-right" data-id="element-416">
            <div className="rounded-2xl overflow-hidden shadow-xl shadow-slate-300/40 border border-slate-200" data-id="element-417">
              <img src="https://cdn.magicpatterns.com/uploads/9dCxjUiqV7wDbE5eDQnv4o/autoglasspic2.webp" alt="Shattered rear window on a vehicle. Kosin's Glass replaces broken rear and side glass." className="block w-full h-64 lg:h-80 object-cover" loading="lazy" data-id="element-418" />
            </div>
            <div className="hidden lg:block absolute -top-4 -left-4 w-24 h-24 bg-brand-blue rounded-2xl -z-10" data-id="element-419" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-420">
          {items.map((item, i) => <div key={i} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.08}s`
        }} data-id="element-421">
              <div className="w-12 h-12 bg-brand-light rounded-xl flex items-center justify-center mb-5" data-id="element-422">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-423">
                {item.title}
              </h3>
              <ul className="space-y-3" data-id="element-424">
                {item.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-425">
                    <CheckCircle2 className="w-5 h-5 text-brand-blue shrink-0 mt-0.5" data-id="element-426" />
                    <span className="text-slate-700" data-id="element-427">{b}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-428">
          <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold py-4 px-8 rounded-xl transition-colors shadow-lg shadow-brand-blue/20" data-id="element-429">
            Request a Side, Door or Rear Window Quote
          </a>
        </div>
      </div>
    </section>;
}